export const REDACTED_TEXT = '[REDACTED]';
export const MAX_REDACTED_TEXT_LENGTH = 4096;

export const ALLOWED_QUERY_PARAMS = new Set([
  'page',
  'pagesize',
  'pagesizelimit',
  'sort',
  'order',
  'tab',
  'view',
  'mode',
  'step',
  'lang',
  'locale',
  'q',
  'query',
  'search',
  'filter',
  'status',
  'type',
  'id',
  'route',
  'feedback',
  'feedbackid',
]);

export const ROUTE_MASK_SEGMENTS = ['admin', 'finance', 'internal', 'private', 'secret'];

export const SENSITIVE_PATTERNS: readonly RegExp[] = [
  /Bearer\s+[A-Za-z0-9._\-+/=]+/gi,
  /\beyJ[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\.[a-zA-Z0-9_-]+\b/g,
  /\b(?:access[_-]?token|refresh[_-]?token|id[_-]?token|auth(?:orization)?|api[_-]?key|client[_-]?secret|secret|password|passwd|pwd|jwt|cookie|session|session[_-]?id|csrf|bearer)\b[\s:=]+[^\s,;]+/gi,
  /\b[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}\b/gi,
  /\b(?:\+?\d[\d\s().-]{7,}\d)\b/g,
  /\b(?:IBAN|bank[_-]?account|account[_-]?number|card[_-]?number)\b[\s:=]+[^\s,;]+/gi,
  /\b(?:employee[_-]?id|employee[_-]?number|staff[_-]?id)\b[\s:=]+[^\s,;]+/gi,
];
